'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
    'use strict';

    angular.module('zp', ['angularMoment', 'ui.router', 'ngStorage', 'datatables', 'ui.bootstrap', 'slick', 'zp.api', 'zp.nav', 'zp.map', 'zp.home', 'zp.news', 'zp.mixes', 'rzModule', 'google.places', 'wu.masonry', 'angular-ladda', '720kb.tooltips', '720kb.socialshare', 'element.visible', 'infinite-scroll', 'ngSanitize', 'cgNotify', 'angularytics', 'ngGeolocation']).config(function (AngularyticsProvider) {
        AngularyticsProvider.setEventHandlers(['Console', 'GoogleUniversal']);
    }).run(function ($rootScope, $state, authService, $anchorScroll, vendorsService, Angularytics, MetaTagsService, GeolocationService) {
        var _MetaTagsService$setD;

        GeolocationService.loadCurrentLocation();
        MetaTagsService.setDefaultTags((_MetaTagsService$setD = {
            // General SEO
            'title': 'Ludi Kamen - Venčanje po vašoj meri',
            'keywords': 'Ludi Kamen - Venčanje po vašoj meri',
            'author': 'Ludi Kamen',
            'description': 'Ludi Kamen je portal sa kompletnom i sveobuhvatnom ponudom iz cele Srbije prostora za venčanja, salona venčanica, zlatara, cvećara, ideja za momačko i devojačko veče i svim ostalim uslugama neophodnim da Vaša veridba ili venčanje bude savršeno.',
            // Indexing / Spiders
            'googlebot': 'all',
            'bingbot': 'all',
            'robots': 'all',
            // OpenGraph
            'og:type': 'website',
            'og:title': 'Ludi Kamen - Venčanje po vašoj meri',
            'og:site_name': 'Ludi Kamen - Venčanje po vašoj meri',
            'og:description': 'Ludi Kamen je portal sa kompletnom i sveobuhvatnom ponudom iz cele Srbije prostora za venčanja, salona venčanica, zlatara, cvećara, ideja za momačko i devojačko veče i svim ostalim uslugama neophodnim da Vaša veridba ili venčanje bude savršeno.',
            'og:image': 'http://ludikamen.co.rs/images/ludi-kamen-share.jpg',
            'og:image:width': '480',
            'og:image:height': '480',
            // Twitter
            'twitter:card': 'summary_large_image',
            'twitter:title': 'Ludi Kamen - Obogatite vaše venčanje sitnicama iz naše prodavnice',
            'twitter:description': 'Ludi Kamen je portal sa kompletnom i sveobuhvatnom ponudom iz cele Srbije prostora za venčanja, salona venčanica, zlatara, cvećara, ideja za momačko i devojačko veče i svim ostalim uslugama neophodnim da Vaša veridba ili venčanje bude savršeno.',
            'twitter:site': '@ludikamen',
            'twitter:creator': '@luedikamen'
        }, _defineProperty(_MetaTagsService$setD, 'twitter:site', 'Ludi Kamen - Venčanje po vašoj meri'), _defineProperty(_MetaTagsService$setD, 'twitter:image:src', 'http://ludikamen.co.rs/images/ludi-kamen-share.jpg'), _defineProperty(_MetaTagsService$setD, 'twitter:domain', 'ludikamen.co.rs'), _MetaTagsService$setD));
        Angularytics.init();
        $rootScope.current_state = $state.current;
        $rootScope.webEnvironment = true;
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.current_state = toState;
            $rootScope.previous_state = fromState;
            MetaTagsService.setFromState(toState, toParams);
            $anchorScroll();
        });
        $rootScope.showLoader = false;
        authService.init();

        vendorsService.getGridConfig();
    });
})();